import styled from '@emotion/styled';
import * as React from 'react';

const RISK_RATINGS = [1, 2, 3, 4, 5, 6, 7];

interface IProps {
  value: number | null | undefined;
  size?: RiskRatingSize;
}

export const RiskRatingChart = styled.div<{
  size: RiskRatingSize;
}>`
  display: flex;
  justify-content: ${(props) =>
    props.size === RiskRatingSize.Large ? 'flex-start' : 'flex-end'};
  align-items: baseline;
`;

export enum RiskRatingSize {
  Small,
  Normal,
  Large,
}

export const RiskRatingBar = styled.div<{
  active: boolean;
  rating: number;
  size: RiskRatingSize;
}>`
  width: ${(props) =>
    props.size === RiskRatingSize.Normal
      ? '4px'
      : props.size === RiskRatingSize.Large
      ? '8px'
      : '2px'};
  margin-right: ${(props) =>
    props.size === RiskRatingSize.Normal
      ? '2px'
      : props.size === RiskRatingSize.Large
      ? '4px'
      : '1px'};
  background: ${(props) =>
    props.active ? props.theme.shades.primary4 : props.theme.shades.primary3};
  opacity: ${(props) => (props.active ? 1 : 0.3)};
  height: ${(props) =>
    (props.size === RiskRatingSize.Normal
      ? 2
      : props.size === RiskRatingSize.Large
      ? 4
      : 1) *
      props.rating +
    (props.size === RiskRatingSize.Small ? 1 : 0)}px;
`;

export function RiskRating({ value, size = RiskRatingSize.Normal }: IProps) {
  if (value === undefined || value === null) return null;

  return (
    <RiskRatingChart size={size}>
      {RISK_RATINGS.map((rating) => (
        <RiskRatingBar
          key={rating}
          active={rating <= value}
          rating={rating}
          size={size}
        />
      ))}
    </RiskRatingChart>
  );
}
